import { exportsModule } from '@cian/mf-registry/browser';

import { createChatsWidgetV2Constructor } from '../services/createChatsWidgetV2Constructor';
import { createContext } from '../services/runApp/createContext';
import { createApplicationState } from '../services/widgetV2State';
import { attachSocketToContext } from '../utils/attachSocketToContext';

export function start() {
  const context = createContext();
  const store = createApplicationState(context);

  attachSocketToContext(context);

  exportsModule({
    ui: {
      '/public/v2/get-chats-widget/': createChatsWidgetV2Constructor(context, store),
    },
  });
}
